import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';

import { Game } from '../classes/game';
import { GameType } from '../classes/game-type';
import { Games, GameTypes } from '../data-test/mock-games/mock-games';

@Injectable()
export class GamesService {

  constructor() { }

  getGames(): Game[] {
    // Todo: send the message _after_ fetching the heroes
    return Games;
  }
  getGameTypes(): GameType[] {
    // Todo: send the message _after_ fetching the heroes
    return GameTypes;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/games.service.ts